import { motion } from 'framer-motion'

const reasons = [
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
      </svg>
    ),
    title: 'Feel Like an IPL Highlight',
    description: 'Professional-grade cinematic editing that makes you look like a star.',
    gradient: 'from-yellow-500/20 to-amber-500/5',
    iconColor: '#ffd700',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    ),
    title: 'Your Name. Your Moment.',
    description: 'Personalized, player-focused edits that celebrate your best plays.',
    gradient: 'from-blue-500/20 to-indigo-500/5',
    iconColor: '#3b82f6',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Perfect for Every Platform',
    description: 'Instagram Reels, YouTube Shorts, WhatsApp Status — optimized formats.',
    gradient: 'from-pink-500/20 to-rose-500/5',
    iconColor: '#ec4899',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    title: 'We Understand Cricket',
    description: 'We know what moments matter — sixes, wickets, catches, run-outs.',
    gradient: 'from-green-500/20 to-emerald-500/5',
    iconColor: '#00ff88',
  },
]

export default function Why() {
  return (
    <section className="py-20 md:py-28 px-4 relative">
      {/* Section divider */}
      <div className="section-divider max-w-4xl mx-auto mb-20" />

      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="inline-block text-xs font-bold text-pitch-green uppercase tracking-[0.2em] mb-4">
            Why Us
          </span>
          <h2 className="text-4xl md:text-5xl font-black mb-4">
            <span className="text-white">Why Cricket Lovers </span>
            <span className="gradient-text">Love This</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-lg mx-auto">
            Because your match deserves more than just a recording.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {reasons.map((reason, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`group relative rounded-2xl p-6 bg-gradient-to-br ${reason.gradient} border border-white/[0.06] backdrop-blur-sm hover:border-white/[0.15] transition-all duration-300 hover:-translate-y-1 cursor-default`}
            >
              {/* Icon */}
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 transition-transform group-hover:scale-110 duration-300"
                style={{ color: reason.iconColor, backgroundColor: reason.iconColor + '15' }}
              >
                {reason.icon}
              </div>

              <h3 className="text-lg font-bold mb-2 text-white">{reason.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{reason.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
